<template>
  <div class="box">
    <div class="header">
      <div class="title">
        <h3>采货侠追差订单</h3>

      </div>
      <div class="search">
        <GlobalForm :inline="true" :init-data="initData" config-icon="el-icon-search" :form-item-list="formItemList"
          confirm-btn-name="查询" @handleConfirm="handleConfirm">
        </GlobalForm>
      </div>
    </div>
    <div class="body" v-loading="tableData.loading">
      <div class="tab_action">
        <TabSelect :tab-data="tabData" :activeIndex="activeIndex" border-radius="4px" @tabAction="tabAction" />
        <div class="taab_left">

          <!-- <el-button type="warning" size="small" @click="automaticallySubmitClick">自动提交售后配置</el-button> -->
          <div class="excel_btn" @click="excelClick">
            <img src="../../../assets/images/excel_dc.png" alt="" />
            <p>导出Excel</p>
          </div>
        </div>
      </div>
      <div v-if="tableData.data.length <= 0" style="
          width: 100%;
          text-align: center;
          padding: 80px 0px;
          font-size: 24px;
          color: rgb(102, 102, 102);
          background: white;
          font-weight: bold;
        ">
        暂无订单~
      </div>
      <div class="table" v-for="(item, index) in tableData.data" :key="index">
        <div class="table_header">
          <div class="table_header_left">
            <p class="table_index">{{ index + 1 }}</p>
            <p>售后单号：{{ item.subArgueNo }}</p>
            <p>订单编号：{{ item.orderNo }}</p>
            <p>外部单号：{{ item.orderNoOneline }}</p>
            <p>
              平台追差状态：{{
                optionsFilter(item.state, platformStateOptions)
              }}
              <el-link type="warning" :underline="true" @click="
                openAction(`/difference/process?argueNo=${item.argueNo}`)
                ">查看详情</el-link>
            </p>
          </div>
          <div class="table_header_right" style="display: flex;align-items: center;">
            <el-tag type="danger" style="margin-right: 5px;"
              v-if="item.applyType == '01' && activeIndex == 2">初审通过自动提交</el-tag>
            <p class="day_num" style="color: #ff687b">
              已入库{{ item.intoDay }}天
            </p>

          </div>
        </div>
        <div>
          <el-table v-if="tableData.data.length > 0" ref="tableName" size="small"
            :header-cell-style="{ padding: 0, backgroundColor: '#F9FBFD' }" :data="[item]">
            <template v-for="item in tableColumns">
              <el-table-column :prop="item.prop" :key="item.prop + item.state" align="center" :label="item.label"
                :width="item.width" :class-name="item.prop === 'action' ? 'action_style' : 'current_row_style'
                  " :fixed="item.prop === 'action' ? 'right' : null" v-if="!item.isHide">
                <template v-slot="{ row }">
                  <!-- 机型名称 -->
                  <div v-if="item.prop === 'phoneName'">
                    <span>{{ row[item.prop] }}</span>
                    <span v-if="row.isElderlyMachine === true">（{{ row.phoneNum }}台）</span>
                  </div>
                  <!-- 旧机照片 -->
                  <div v-else-if="item.prop === 'images'" class="photo_list">
                    <img :src="row[item.prop][0].smallImg" alt="" />
                    <p @click="voucherView(row[item.prop])" class="lv_fc_line">
                      共{{ row[item.prop].length }}张
                    </p>
                  </div>
                  <!-- 串号 -->
                  <div v-else-if="item.prop === 'imei'">
                    <p>{{ row[item.prop] }}</p>
                    <p class="lv_fc_line" @click="$refs['functionDia'].open(row)">
                      功能情况
                    </p>
                  </div>
                  <!-- 初审人 -->
                  <div v-else-if="item.prop === 'auditFirstAdminName'">
                    {{ row.auditFirstAdminName }}-{{ row.auditFirstAdminAcc }}
                  </div>
                  <!-- 提交人 -->
                  <div v-else-if="item.prop === 'applyAdminAcc'">
                    {{ row.applyAdminName }}-{{ row.applyAdminAcc }}
                  </div>
                  <!-- 售后原因 -->
                  <div v-else-if="item.prop === 'argueNote'">
                    <el-tooltip class="item" effect="dark" :content="row.argueNote" placement="top">
                      <div class="lv_ycyc2">{{ row.argueNote }}</div>

                    </el-tooltip>

                  </div>
                  <!-- 审核备注 -->
                  <div v-else-if="item.prop === 'auditNote'">
                    <el-tooltip class="item" effect="dark" :content="row.auditNote" placement="top">
                      <div class="lv_ycyc2">{{ row.auditNote }}</div>

                    </el-tooltip>

                  </div>
                  <!-- 操作 -->
                  <div v-else-if="item.prop === 'action'" class="action_box" :key="item.state">
                    <el-button v-if="activeIndex == 0" type="danger"
                      @click="$refs['reviewApplyDia'].open(row, 'anewcreate')">申请追差</el-button>
                    <el-button v-else type="primary" plain round
                      @click="$refs['reviewApplyDia'].open(row, 'detail')">查看售后详情</el-button>
                    <el-button v-if="activeIndex == 0" type="danger" plain @click="detaleShow = true,detRow = row">移除订单</el-button>
                  </div>
                  <div v-else>
                    {{ row[item.prop] }}
                  </div>
                </template>
              </el-table-column>
            </template>
          </el-table>
        </div>
      </div>
    <el-dialog
      title="操作提示"
      :visible.sync="detaleShow"
      :close-on-click-modal="false"
      width="550px"
      @closed="detaleShow = false,getData(),command = ''"
    >
      <p style="color: red; margin-bottom: 10px">
       说明：移除后，该订单不会再出现在该列表。如订单仍需追差，请通过平台差异订单操作
      </p>
      <div class="cance-tip">
        <div class="tip-sure">
      是否确认移除追差订单？
        </div>
       </div> 
      <div class="command">
        <div style="width: 88px">动态口令：</div>
        <el-input
          v-model="command"
          placeholder="请输入谷歌动态口令"
          oninput="this.value = this.value.replace(/[^0-9a-zA-Z]/ig,'')"
        ></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click.native="detaleShow = false">取消</el-button>
        <el-button
          type="primary"
          :loading="excelLoading"
          @click.native="detaleDialogSubmit"
          >确定</el-button
        >
      </span>
    </el-dialog>
      <el-dialog title="自动提交外部售后配置" :visible.sync="automaticallySubmitVisible" :close-on-click-modal="false"
        width="900px" @closed="automaticallySubmitVisible = false, code = ''">
        <div class="button_top">
          <div class="radiobtn">
            <div class="faultBtn">
              <div v-bind:class="automaticallyClickShow === '01' ? 'active' : 'none'"
                @click="automaticallyChange('01')">
                启用自动提交说明
              </div>
              <div v-bind:class="automaticallyClickShow === '02' ? 'active' : 'none'"
                @click="automaticallyChange('02')">
                启用/关闭自动提交
              </div>
            </div>
          </div>
        </div>
        <el-table :data="describeData" style="width: 100%;margin: 50px 0;" v-if="automaticallyClickShow == '01'">
          <el-table-column type="index" width="50" label="序号" align='center'>
          </el-table-column>
          <el-table-column prop="type" label="类型" width="160" align='center'>
            <template slot-scope="scope">
              <span style="font-weight: 800;">{{ scope.row.type }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="shuoming" label="取值说明" header-align='center'>
            <template slot-scope="scope" style="margin: 5px;">
              <div style="color: #0981FF;" v-for="(item, index) of scope.row.shuoming" :key="index">
                {{ item }}
              </div>
            </template>
          </el-table-column>
        </el-table>

        <el-table :data="automaticallyTableData" style="width: 100%;margin: 50px 0;"
          v-if="automaticallyClickShow == '02'">
          <el-table-column type="index" width="50" label="序号" align='center'>
          </el-table-column>
          <el-table-column v-for="(item, index) of automaticallyColumn" :key="index" :prop="item.prop"
            :label="item.label" align='center'>
          </el-table-column>
          <el-table-column  label="渠道唯一路由" align='center'>
            <template slot-scope="scope">
        {{ scope.row.code || '--' }}
            </template>
          </el-table-column>
          <el-table-column prop="isSubmit" label="初审通过自动向外部提交追差" align='center'>
            <template slot-scope="scope">
              <el-switch :disabled="!scope.row.isApr" v-model="scope.row.isSubmit" @change="autoAprChange(scope.row)">
              </el-switch>
            </template>
          </el-table-column>
        </el-table>
      </el-dialog>
      <!-- 输入谷歌验证 -->
      <el-dialog :title="codeTitle" :visible.sync="codeShow" :close-on-click-modal="false" width="500px"
        @closed="codeShow = false, code = '', getAutoApplyChannelList()">
        <div v-if="codeTitle != '操作提示'" style="color: red;">

          <span v-if="codeTitle ==
            '启用提示'">说明：开启后，该商户追差订单平台初审通过后将自动提交售后给外部。开启前请先了解启用说明</span>
          <span v-else>说明：关闭后，该商户追差订单平台初审通过后，不再自动提交售后给外部</span>
        </div>
        <div v-if="codeTitle == '操作提示'" class="cance-tip" style="margin-bottom: 20px;">
          <div class="tip-sure" style="margin-top: 10px;color: #333333;font-size: 16px;text-align: center;">是否确认导出？
          </div>
        </div>
        <div v-else
          style="font-weight: 600; display: flex;justify-content: center;align-items: center; margin: 15px 0;">
          <span>是否确认</span>
          <span>{{ automaticallyRow.isSubmit ? '开启' : '关闭' }}</span>
          <span style="color: #0981FF;">{{ automaticallyRow.companyName }}</span>
          <span>自动提交追差功能？</span>
        </div>
        <div style="display: flex; align-items: center; margin-bottom: 10px;">
          <div style="width: 88px">动态口令：</div>
          <el-input v-model="code" placeholder="请输入谷歌动态口令"
            oninput="this.value = this.value.replace(/[^0-9a-zA-Z]/ig,'')"></el-input>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click.native="codeShow = false, code = ''">取消</el-button>
          <el-button type="primary" :loading="excelLoading" @click.native="codeSubmit">确定</el-button>
        </span>
      </el-dialog>

      <Pagination :meta="meta" @sizeChange="
        (v) => {
          meta = { ...meta, pageSize: v };
          params = { ...params, pageSize: v };
        }
      " @pageChange="
        (v) => {
          meta = { ...meta, pageNum: v };
          params = { ...params, pageNum: v };
        }
      " />
    </div>
    <PhotoPreview :photoVisible="photoDialogProp.show" :photoArr="photoDialogProp.photoArr" title="旧机照片"
      @close="() => (photoDialogProp.show = false)" />
    <ReviewApplyDia ref="reviewApplyDia" />
    <FunctionDia ref="functionDia" />
  </div>
</template>
<script>
import {
  formItemList,
  photoDialogProp,
  platformTableColumns,
  tabData,
  tableData,
  platformStateOptions,
  describeData
} from "./initState";
import _api from "@/utils/request";
import { http } from "@/utils/request/caiHuoXiaReview"

import moment from "moment";
import {
  getHaoTime,
  getMeta,
  guideExcelAction,
  openAction,
  pageSize,
} from "@/utils/common";
import PhotoPreview from "@/components/common/PhotoPreview.vue";
import TabSelect from "@/components/common/TabSelect.vue";
import GlobalForm from "@/components/global/components/GlobalForm.vue";
import Pagination from "@/components/common/Pagination.vue";
import ReviewApplyDia from "./componets/ReviewApplyDia.vue";
import FunctionDia from "../componets/FunctionDia.vue";
export default {
  components: {
    Pagination,
    GlobalForm,
    TabSelect,
    PhotoPreview,
    ReviewApplyDia,
    FunctionDia,
  },
  computed: {

  },

  data() {
    const startTime = moment()
      .subtract(30, "day")
      .startOf("day")
      .format("YYYY-MM-DD");
    const endTime = moment().endOf("day").format("YYYY-MM-DD");
    const time = [startTime, endTime];
    const { orderNo } = this.$route.query; //订单详情跳转过来携带订单号,//差异详情跳转过来携带state
    console.log(tabData);
    return {
      codeShow: false,
      code: '',
      codeTitle: '',

      platformStateOptions,

      tabActive: 0, //tab

      activeIndex: 0, //tab初始选择索引
      tabData,
      tableData,
      // 嵌套过深，element无法检测到
      tableColumns: JSON.parse(JSON.stringify(platformTableColumns)),
      initData: {
        createTime: time,
        orderNo,
      },
      // 分页数据
      meta: {
        total: 0,
        pageSize,
        pageNum: 1,
      },
      // 搜索参
      params: {
        pageSize,
        pageNum: 1,
        chxState: '00',
        orderNo,
        createTime: time, //申请时间默认62天
        // auditTime: time,
        // closeTime: time,
      },
      // 搜索列表
      formItemList,
      // 旧机照片弹窗
      photoDialogProp,



      excelLoading: false,

      automaticallySubmitVisible: false,
      automaticallyClickShow: '01',
      automaticallyColumn: [
        {
          prop: 'channelName',
          label: '渠道商名称'
        },
        {
          prop: 'companyName',
          label: '门店商户'
        },
        // {
        //   prop: 'code',
        //   label: '渠道商编号'
        // }
      ],
      automaticallyTableData: [],
      describeData,
      automaticallyRow: {},
      detaleShow:false,
      detRow:{},
      command:'',

    };
  },
  created() {
    // 下拉
    this.getSelectList();
    // 列表
    this.activeIndex = 0;
    this.getData('00');

  },
  watch: {
    params(v) {
      this.getData();
    },


  },
  methods: {
    openAction,
    detaleDialogSubmit(){
         if (!this.command) {
        return this.$message.error("请输入谷歌动态码");
      }
      const {argueNo,subArgueNo} = this.detRow
      this.excelLoading = true
         http.removeWaitApply({argueNo,subArgueNo,command:this.command}).then((res) => {
           this.detaleShow = false
           this.command = ''
           this.$message.success('操作成功');
            this.excelLoading = false
            this.getData();

      }).finally(() => {
      this.excelLoading = false

      })
    },
    automaticallySubmitClick() {
      this.automaticallySubmitVisible = true
      this.getAutoApplyChannelList()
    },
    getAutoApplyChannelList() {
      http.autoApplyChannelList({channelCode:'chx'}).then((res) => {
        this.automaticallyTableData = res.data
      }).finally(() => {

      })
    },
    automaticallyChange(val) {
      this.automaticallyClickShow = val
    },
    autoAprChange(row) {
      console.log(row, 111);
      const { isSubmit } = row
      this.automaticallyRow = row
      this.codeShow = true
      this.codeTitle = isSubmit ? '启用提示' : '禁用提示'
    },



    //设置时间戳
    setParamsTIme(params, key, startKey, endKey) {
      return {
        ...params,
        [startKey]: getHaoTime(params[key][0], "start"),
        [endKey]: getHaoTime(params[key][1], "end"),
        [key]: null,
      };
    },
    // time时间是否重置
    resetTime(params, key, startKey, endKey) {
      if (Array.isArray(params[key])) {
        params = this.setParamsTIme(params, key, startKey, endKey);
      } else {
        params[key] = null;
        params[startKey] = null;
        params[endKey] = null;
      }
      return params;
    },
    // 各种状态的数量设置
    setStateNum(data) {
      this.tabData = this.tabData.map((v) => {
        if (data[v.key] >= 1000) {
          v.num = data[v.key] / 1000 + "k";
        } else {
          v.num = data[v.key] || 0;
        }
        return v;
      });
    },
    getData(chxState) {
      this.tableData.loading = true;
      let params = this.params;
      params = this.resetTime(
        params,
        "intoTime",
        "intoStartTime",
        "intoEndTime"
      );
      params = this.resetTime(
        params,
        "auditFirstTime",
        "auditFirstStartTime",
        "auditFirstEndTime"
      );
      params = this.resetTime(
        params,
        "createTime",
        "createStartTime",
        "createEndTime"
      );
      params = this.resetTime(
        params,
        "finishTime",
        "finishStartTime",
        "finishEndTime"
      );
      params = this.resetTime(
        params,
        "rejectTime",
        "rejectStartTime",
        "rejectEndTime"
      );
      if (chxState) {
        params.chxState = chxState;
      }
      http.aprchxList(params).then((r) => {
        this.tableData.loading = false;
        const data = r.data ?? {};
        const page = data.page ?? {};
        this.setStateNum(data);
        const records = Array.isArray(page.records) ? page.records : [];
        this.tableData.data = records;


        // 分页
        this.meta = getMeta(page.total, params.pageNum, params.pageSize);
      }).finally(() => {
        if (typeof this.params.disuseLoding == "function") {
          this.params.disuseLoding();
        }
      })
    },
    getSelectList() {
      const data = {
        pageNum: 1,
        pageSize: 9999,
      };
      // 回收商rq
      _api.listSimpleMerchantView(data).then((r) => {
        const index = this.formItemList.findIndex(
          (v) => v.key === "merchantId"
        );
        const data = Array.isArray(r.data) ? r.data : [];
        this.formItemList[index].option = data.map((v) => {
          return {
            label: v.merchantName,
            value: v.merchantId,
          };
        });
      });
      // 询价商
      _api.getSelectList().then((r) => {
        const index = this.formItemList.findIndex((v) => v.key === "companyId");
        const data = Array.isArray(r.data) ? r.data : [];
        this.formItemList[index].option = data.map((v) => {
          return {
            label: v.name,
            value: v.id,
          };
        });
      });

    },


    // 搜索确定
    handleConfirm(v, cd) {

      this.params = {
        ...this.params,
        ...v,
        pageNum: 1,
        disuseLoding: () => {
          if (typeof cd === 'function') {
            cd();
          }
        },
      }
    },
    // 根据状态设置列/和查询条件项
    setStateColumns(v) {
      this.tabActive = v;
      const tableColumns = JSON.parse(JSON.stringify(platformTableColumns));
      let activeIndex = 0,
        showColums = [];
      switch (v) {
        case '00':
          // 待申请
          activeIndex = 0;
          showColums = [

          ];
          break;
        case '01':
          // 待审核
          activeIndex = 1;
          showColums = [
            "applyAdminName", "applyTime", "arguePrice"

          ];
          break;
        case '02':
          // 已通过
          activeIndex = 2;
          showColums = [
            "applyAdminName", "applyTime", "arguePrice",
            "finishTime", "amount", "auditNote",

          ];
          break;
        case '10':
          // 已驳回
          activeIndex = 10;
          showColums = [
            "applyAdminName", "applyTime", "arguePrice",
            "rejectTime", "auditNote"
          ];
          break;
      }
      this.activeIndex = activeIndex;
      if (activeIndex != 0) {
        tableColumns.forEach((item) => {
          if (["auditFirstAdminName", "auditFirstTime", "arguePriceAuditS",].includes(item.prop)) item.isHide = true;
        });
      }
      tableColumns.forEach((item) => {
        if (showColums.includes(item.prop)) item.isHide = false;
      });
      this.tableColumns = tableColumns;
      console.log('tableColumns', tableColumns);

    },
    // 状态操作
    tabAction(v) {
      console.log(this.tabData[v]);
      const chxState = this.tabData[v].value;
      this.params = {
        ...this.params,
        pageNum: 1,
        chxState,
      };
      this.setStateColumns(chxState);
    },

    // 照片预览
    voucherView(images) {
      this.photoDialogProp = {
        ...this.photoDialogProp,
        show: true,
        photoArr: images.map((item) => item.img),
      };
    },

    //导表
    excelClick() {
      console.log(111);

      this.codeShow = true
      this.codeTitle = '操作提示'
    },
    codeSubmit() {
      if (!this.code) {
        return this.$message.error("请输入谷歌动态码");
      }
      if (this.codeTitle == '操作提示') {
        this.params.command = this.code
        let params = this.params;
        params = this.resetTime(
          params,
          "intoTime",
          "intoStartTime",
          "intoEndTime"
        );
        params = this.resetTime(
          params,
          "auditFirstTime",
          "auditFirstStartTime",
          "auditFirstEndTime"
        );
        params = this.resetTime(
          params,
          "createTime",
          "createStartTime",
          "createEndTime"
        );
        params = this.resetTime(
          params,
          "finishTime",
          "finishStartTime",
          "finishEndTime"
        );
        params = this.resetTime(
          params,
          "rejectTime",
          "rejectStartTime",
          "rejectEndTime"
        );
        this.excelLoading = true;
        http.aprchxExcel(params).then((r) => {
          guideExcelAction(r, "采货侠差异订单", () => {
            this.excelLoading = false;
            this.codeShow = false
          });
        });
      } else {
        this.excelLoading = true;
        const { id, isSubmit } = this.automaticallyRow
        http.automaticSubmission({ id, isSubmit, command: this.code }).then((r) => {
          this.getAutoApplyChannelList()
          this.excelLoading = false;
          this.codeShow = false
          return this.$message.success(r.msg);

        });
      }

    },

    optionsFilter(v, options) {
      return options.find((item) => item.value == v)?.label;
    },
  },
};
</script>

<style scoped lang="scss">
.button_top {
  cursor: pointer;
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.faultBtn {
  width: 300px;
  height: 42px;
  background: #f9fbfd;
  border: 1px solid #c1d1ff;
  box-shadow: 0px 4px 8px 0px rgba(196, 197, 198, 0.2);
  border-radius: 21px;
  display: flex;

  .active {
    text-align: center;
    color: white;
    width: 50%;
    height: 40px;
    font-size: 14px;
    font-family: FZLanTingHei-M-GBK;
    font-weight: 400;
    line-height: 40px;
    background: #0981ff;
    border-radius: 20px;
  }

  .none {
    text-align: center;
    color: #333;
    width: 50%;
    height: 40px;
    font-size: 14px;
    font-family: FZLanTingHei-M-GBK;
    font-weight: 400;
    line-height: 40px;
    border-radius: 20px;
  }
}

.fileName {
  /deep/.el-input {
    width: 260px;
  }

  /deep/.el-button {
    // border-radius: 10px;
    margin-right: 0px;
  }
}

.impor_bottom {
  // display: flex;
  // align-items: center;
  // justify-content: space-between;
  margin-bottom: 30px;

  .inquery {
    color: #4c84ff;
    position: relative;
    padding-left: 20px;
  }

  .inquery::before {
    content: "";
    display: block;
    width: 6px;
    height: 6px;
    background: #4c84ff;
    border-radius: 50%;
    position: absolute;
    left: 10px;
    top: 50%;
    transform: translateY(-50%);
  }
}

.jus_spa {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.jus_end {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.import_box {
  margin-top: 20px;
  display: flex;
  align-items: center;
}

.impor_tip {
  color: #ff5c5c;
  font-size: 14px;
  margin-top: 20px;
  margin-bottom: 40px;
  padding-left: 64px;
}

.impor_inp {
  width: 200px;
  height: 34px;
  border: 1px solid #c1d1ff;
  background-color: #f9fbfd;
  border-radius: 6px;
}

.cance_tip {
  color: #ff8080;
  font-size: 14px;
  margin-bottom: 20px;
}

.remarkBtn {
  color: #0981ff;
  cursor: pointer;
  text-decoration: underline;
}

.function_box {
  max-height: 700px;
  overflow: auto;
}

.box {
  >.header {
    width: 100%;
    background: #ffffff;
    border-radius: 4px;
    padding: 18px 20px 24px 15px;
    box-sizing: border-box;

    >.title {
      width: 100%;
      display: flex;
      align-items: center;

      >img {
        width: 30px;
        height: 30px;
        margin-right: 9px;
      }

      >h3 {
        font-size: 16px;
        font-weight: 700;
        color: #333333;
        margin-right: 8px;
        transform: translateY(-1px);
      }

      >p {
        font-size: 14px;
        font-weight: 400;
        color: #4c84ff;
      }
    }

    >.search {
      margin-top: 12px;
      width: 100%;
      box-sizing: border-box;
      padding: 15px 14px 0px 14px;
      background: #f5f6fa;
      border-radius: 4px;
    }
  }
}

.box {
  /deep/ .current_row_style .cell {
    line-height: 20px;
    padding: 10px;
  }

  ///deep/ .action_style .cell{
  //  visibility: visible !important;
  //  position: relative;
  //  z-index: 1999;
  //}

  ///deep/ .action_style .action_box{
  //  overflow: hidden;
  //}
  //
  ///deep/ .el-table__body-wrapper .action_style .action_box{
  //  display: none;
  //}

  /deep/ .photo_list img {
    width: 60px;
    height: 60px;
  }

  >.body {
    margin-top: 15px;
    width: 100%;
    border-radius: 4px;
    background: #fff;
    padding: 14px 20px 14px 17px;
    box-sizing: border-box;

    >.table {
      margin-top: 14px;

      >.table_header {
        width: 100%;
        padding: 11px 0;
        padding-right: 10px;
        border-radius: 4px 4px 0px 0px;
        background: #e9f0fe;
        display: flex;
        align-items: center;
        justify-content: space-between;

        >.table_header_left {
          display: flex;
          align-items: center;
          font-size: 14px;
          font-weight: 400;
          color: #4c84ff;
          justify-content: space-between;

          >p {
            margin-right: 30px;
          }

          >.table_index {
            width: 30px;
            height: 18px;
            background: #f5b724;
            border-radius: 3px 9px 9px 3px;
            text-align: center;
            line-height: 18px;
            margin-right: 9px;
            font-size: 14px;
            font-weight: 400;
            color: #ffffff;
          }
        }

        >.table_header_right {
          >.day_num {
            font-size: 12px;
            font-weight: 400;
            color: #ff687b;
          }
        }
      }

      /deep/ .el-table .el-table__header th {
        background: #f9fbfd !important;
        border-width: 0;
        border-bottom-width: 1px;
      }
    }
  }
}

.tab_action {
  display: flex;
  align-items: center;
  justify-content: space-between;

  .taab_left {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .excel_btn {
    margin-left: 20px;
    height: 30px;
    cursor: pointer;
    background: #50cd85;
    border-radius: 4px;
    display: flex;
    font-size: 12px;
    font-weight: 400;
    color: #ffffff;
    align-items: center;
    padding: 0 9px;

    img {
      margin-right: 2px;
      width: 16px;
      height: 16px;
    }
  }
}

.photo_list {
  >img {
    width: 70px;
    height: 70px;
    object-fit: cover;
  }
}

.channel_name {
  padding: 0 11px;
  height: 20px;
  background: #ffffff;
  border: 1px solid #ffaf29;
  border-radius: 10px;
  font-size: 12px;
  font-weight: 400;
  color: #ffaf29;
  line-height: 20px;
}

.matrix_name {
  padding: 0 11px;
  height: 20px;
  background: #ffffff;
  border: 1px solid #21d8c2;
  border-radius: 10px;
  font-size: 12px;
  font-weight: 400;
  color: #21d8c2;
  line-height: 20px;
}

.apply_times {
  padding: 0 11px;
  height: 20px;
  background: #ffffff;
  border: 1px solid #ff5c5c;
  border-radius: 10px;
  font-size: 12px;
  font-weight: 400;
  color: #ff5c5c;
  line-height: 20px;
}

.blue_color {
  border: 1px solid #4c84ff;
  color: #4c84ff;
}

.action_box {
  display: flex;
  align-items: center;
  justify-content: space-around;

  >p {
    flex: 1;
    text-align: center;
  }
}

// 弹窗
.img-box {
  margin-bottom: 20px;

  // 图片
  .imgs-num {
    text-align: center;
    margin: 5px 0;
    font-weight: bold;
  }

  .img-tips-box {
    display: flex;
    height: 30px;
    width: max-content;
    border: 1px solid #0981ff;

    .img-tips {
      width: 80px;
      text-align: center;
      line-height: 30px;
      box-sizing: border-box;
      cursor: pointer;
    }

    .img-tips-default {
      background: #fff;
      color: #0981ff;
    }

    .img-tips-choose {
      background: #0981ff;
      color: #fff;
    }
  }

  // 列表
}

.rejetct_box {
  .reject_duty {
    display: flex;
    align-items: center;
  }

  .reject_basis {
    margin-top: 10px;

    /deep/ .box .list_box p {
      width: 80px;
    }
  }
}

.order_num {
  margin-left: 10px;
  background: #e4ecfd;
  border-radius: 4px;
  padding: 6px;
}

//去除数字框上下箭头
/deep/ input::-webkit-outer-spin-button,
/deep/ input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
}

/deep/ input[type="number"] {
  -moz-appearance: textfield;
}

///deep/.table_header_style{
//}

.paste-img-box {
  display: flex;

  .img-item {
    position: relative;
    margin-right: 20px;

    .el-icon-circle-close {
      font-size: 30px;
      position: absolute;
      top: -15px;
      right: -15px;
      z-index: 5;
      color: #fd677d;
    }

    .img {
      width: 100px;
      height: 100px;
    }
  }
}
.cance-tip {
  color: #ff8080;
  font-size: 14px;
  margin-bottom: 20px;

  .tip-sure {
    margin-top: 10px;
    color: #333333;
    font-size: 16px;
    text-align: center;
  }
}
.command {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
</style>
